function imageTransferables(image) {
    return [
        image.data,
        image.direction
    ];
}
export default imageTransferables;
//# sourceMappingURL=image-transferables.js.map